import React, { useEffect } from "react";
import News from "./News";
import WhyInvest from "./WhyInvest";
import {
  useGetMainQuery,
} from "services/clientApi";
import { useNavigate } from "react-router-dom";

const Investments = () => {
  const navigate = useNavigate();
  const { data: main, isLoading: loading, isError: error, refetch } = useGetMainQuery();
  const logOut = () => {
    localStorage.removeItem("isClient");
    localStorage.removeItem("auth_client");
    navigate("/login");
    window.location.reload();
  };

  if (error) {
    logOut()
  }

  useEffect(() => {
    refetch();
    const interval = setInterval(() => {
      refetch();
    }, 60000);

    return () => clearInterval(interval);
  }, [refetch]);
  return (
    <div style={{ overflow: "auto" }}>
      <div>
        <News />
        <WhyInvest />
      </div>
    </div>
  );
};

export default Investments;
